
export type CreateChatThreadBody = {
  /** @nullable */
  isGroupThread?: boolean | null;
  participantIds: string[];
};
